import formInputsTypes from 'constants/simulatorData/simulatorConstant';
import {
    isWithAgraffe,
    LameColor,
    LameTaille,
} from 'constants/simulatorDataDetails/simulatorConstant';
import { MesureLargeur } from '../rideauMetallique/data';

const attaches = {
    id: 'attaches',
    type: formInputsTypes?.INPUT_NUMBER,
    name: 'attaches',
    className: 'col-6',
    label: 'Nombre Agraffe Rigide',
    defaultValue: 0,
    nextStepData: false,
    nextStep: false,
    validation: (value) => {
        return value > 0;
    },
};
const coulisse = {
    id: 'VR-TR-TB-CLIS',
    type: formInputsTypes?.RADIO_INPUT,
    name: 'coulisse',
    className: 'col-6',
    label: 'Avec Coulisse',
    defaultValue: 0,
    nextStepData: false,
    nextStep: false,
    options: [
        {
            id: 'with-coulisse',
            label: 'Oui',
            value: 'oui',
            checked: true,
            nextStep: LameColor(isWithAgraffe(attaches, false), 'Couleur de coulisse'),
        },
        {
            id: 'without-coulisse',
            label: 'Non',
            value: 'non',
            checked: false,
            nextStep: isWithAgraffe(attaches, false),
        },
    ],
};


const TypeMesureHaut = {
    id: 'VR-TR-TB-TMH',
    type: formInputsTypes?.RADIO_INPUT,
    name: 'typeMesureHauteur',
    className: 'col-6',
    label: 'Mesure selon Hauteur',
    nextStepData: LameTaille(
        LameColor(coulisse, 'Couleur de lame'),
    ),
    nextStep: false,

    fetchData: (currentFormValue, fnSuccess) => {
        const hauteur = currentFormValue?.values?.hauteur?.value;

        const options = [
            {
                id: 'RMFN',
                label: 'FINI',
                value: 'FINI',
                nextStep: false,
                description: `- Hauteur : ${hauteur} mm FINI`

            },
            {
                id: '+E',
                label: '+E',
                value: '+E',
                nextStep: false,
                description: `- Hauteur : ${hauteur} mm +E`


            },

        ]
        fnSuccess(options);
    },
};

const hieghtTablier = {
    id: 'VR-TR-TB-H',
    type: formInputsTypes?.INPUT_NUMBER,
    name: 'hauteur',
    className: 'col-6',
    label: 'Hauteur (mm)',
    defaultValue: 0,
    nextStepData: TypeMesureHaut,
    nextStep: false,
    notIncludeDescription: true,
    validation: (value) => {
        return value >= 0;
    },
};

const typeMesureLargeur = {
    id: 'VR-TR-TB-TMW',
    type: formInputsTypes?.RADIO_INPUT,
    name: 'typeMesureLargeur',
    className: 'col-6',
    label: 'Mesure selon largeur',
    nextStepData: hieghtTablier,
    nextStep: false,
    fetchData: (currentFormValue, fnSuccess) => {
        const largeur = currentFormValue?.values?.largeur?.value;

        const options = [
            {
                id: 'RMFN',
                label: 'FINI',
                value: 'FINI',
                nextStep: false,
                description: `- Largeur : ${largeur} mm FINI`

            },
            {
                id: 'RME',
                label: 'DC',
                value: 'DC',
                nextStep: false,
                description: `- Largeur : ${largeur} mm D.C`


            },

        ]
        fnSuccess(options);
    },
};

const TablierVolet = {
    id: 'VR-TR-TB-W',
    type: formInputsTypes?.INPUT_NUMBER,
    name: 'largeur',
    className: 'col-6',
    label: 'Largeur (mm)',
    defaultValue: 0,
    nextStepData: typeMesureLargeur,
    nextStep: false,
    notIncludeDescription: true,
    validation: (value) => {
        return value >= 0;
    },
};

export default TablierVolet;
